<template lang="pug">
  .container
    .roll-order-infos(ref="rollOrder")
      div(v-for="item in rollPool") {{item}} 1分钟前办理
    .header
      img.banner(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/chongqing/header.png?x-oss-process=style/414_jpeg_zoom")
    .mobile-form
      el-form.form-content
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入重庆移动手机号")
        el-form-item
          el-row.verify-controls
            el-input(type="text", placeholder="请输入短信验证码", v-model="form.verifyCode", maxlength="4")
            el-button(:disabled="leftSendTime > 0", @click="sendVerifyCode")
              span(v-if="leftSendTime <= 0") 获取验证码
              span(v-else) {{leftSendTime}}秒后可重试
        el-form-item.submit-btn
           img(src="../../../public/images/shaanxi/janvideoflow-button.png", @click="handleSubmit")
    .tip 注；30元10G流量包，每个月赠送视频会员月卡，合约期12个月。
    .show-more(v-if="!isShowMore", @click="isShowMore = true")
      .inner-arrow
    div(v-else)
      .img-desc
        img(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/chongqing/desc.png?x-oss-process=style/414_jpeg_zoom")
      .notice
        .title ········活动说明········
        ul
          li(v-for="(notice, index) in notices", :key="index")
            .num {{index + 1}}.
            p.content(v-if="typeof(notice) === 'string'", v-html="notice")
            P.content(v-else)
              | {{notice.text}}
              div(v-for="child in notice.children", :key="child", v-html="child")
      el-dialog(
        width="80%",
        title="提示",
        :visible.sync="dialogVisible",
        :before-close="handleClose"
      )
        .dialog-content
          div
            | 您要为手机号：
            span.mobile-info {{form.mobile}}
          div
            | 办理业务：
            span.package-info {{selectedPackage.name}}
        span.dialog-footer(slot="footer")
          el-button(@click="dialogVisible = false") 取消
          el-button(type="primary", @click="handleSubmit") 确定
</template>

<script>

// 推啊=TUIA、豆盟=DOUMENG、快手=KUAISHOU
export default {
  data() {
    return {
      errlog: '',
      rollPool: ['136****3827', '137****1974'],
      shareNoticeVisiable: false,
      showMoreNotice: false,
      dialogVisible: false,
      isShowMore: true,
      leftSendTime: 0,
      channel: 'TUIA',
      rollOrderTop: 0.5,
      form: {
        carrierId: 15,
        mobile: '',
        verifyCode: '',
        userId: null,
        sharerId: null,
        exchangeId: ''
      },
      notices: [
        '业务资费：5G畅享权益包，本产品采用话费支付，订购立即生效，资费30元/月，合约期12个月，合约期内不能取消。合约到期后，如不取消按30元/月续订（可在合约期最后一月取消，退订次月生效）。合约期内不能办理过户、销户、合户、分户和停机保号业务，提前取消需进行违约金赔付。',
        {
          text: '本产品权益：',
          children: [
            '（1）本产品包含10GB流量（5GB全国通用流量(不含港澳台)+ 5GB定向流量）。流量到账当月内有效，不可共享/转赠/结转。',
            '（2）本产品定向流量月包（自然月，非30天），支持在优酷、百度系、爱奇艺、今日头条、抖音、咪咕视频、快手使用。（不包括APP中第三方广告、弹幕、视频上传、APP内跳转第三方网站等产生的流量）',
            '（3）每自然月内可领取一个会员权益。成功领取后会员有效期30天，会员有效期在您原有会员有效期上顺延。',
            '（4）本产品包含5G优享网速权益，使用5G手机在5G网络覆盖区域即可体验5G网速权益。',
            '（5）本产品权益包含家庭云盘（200G）、视频彩铃（基础功能）、云VR体验权益（以上三个权益均为体验3个月），到期自动取消不收取费用。'
          ]
        },
        {
          text: '权益领取规则：',
          children: [
            '（1）业务生效期间，每自然月1日起至月底，您可领取当月权益。领取机会当月有效，当月未领则作废不积累至下月，即未领取次月不能补领。',
            '（2）会员VIP领取后30分钟内充值到账。领取成功后，会员VIP时长将在您原有会员时长上顺延。请直接使用手机号码、验证码登录APP查看您的会员VIP到账情况。'
          ]
        },
        '权益领取范围：爱奇艺月会员、腾讯视频月会员、优酷月会员、哔哩哔哩月会员、芒果TV月会员、咪咕视频月会员、酷狗音乐月会员、QQ音乐月会员、酷我音乐月会员、咪咕音乐月会员、掌阅月会员、喜马拉雅月会员、QQ阅读月会员、蜻蜓FM月会员、咪咕阅读月会员（具体以权益领取页面为准）。',
        '权益领取入口：本产品订购生效后可在重庆移动手厅“我的”—“我的权益”登录领取权益。',
        '本产品限重庆移动客户办理，数据卡、物联网卡、欠费、停机、及手机状态不正常的客户不可办理本业务。'
      ],
      selectedPackage: {},
      packageList: [
        {
          goodsCode: 'TUIA20210323001'
        }
      ]
    }
  },
  mounted() {
    this.handleSelected(this.packageList[0])
    setTimeout(() => {
      this.rollOrder()
    }, 2000)
  },
  methods: {
    rollOrder() {
      if (this.rollOrderTop < 1.2) {
        this.$refs.rollOrder.querySelector('div').style.marginTop = `-${this.rollOrderTop}rem`
        setTimeout(() => {
          this.rollOrderTop += 0.2
          this.rollOrder()
        }, 80)
      } else {
        let _numPrefix = [138, 137, 136]
        let _num = 9999 - Math.floor(Math.random() * 8999)
        this.rollPool.push(`${_numPrefix[Math.floor(Math.random() * 3)]}****${_num}`)
        this.$refs.rollOrder.querySelector('div').style.marginTop = '0.5rem'
        this.rollPool.splice(0, 1)
        this.rollOrderTop = 0.5
        setTimeout(() => {
          this.rollOrder()
        }, 2000)
      }
    },
    handleSelected(selectedPackage) {
      this.selectedPackage = selectedPackage
    },
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            this.form.exchangeId = res.data.sub_data.exchangeId
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    showConfirm() {
      this.dialogVisible = true
    },
    checkMobile() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 4) {
        this.$message({
          type: 'warning',
          message: '请填写4位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.selectedPackage.goodsCode,
          exchangeId: this.form.exchangeId,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.isCheckMobile = true
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleSubmit() {
      this.dialogVisible = false
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 4) {
        this.$message({
          type: 'warning',
          message: '请填写4位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          exchangeId: this.form.exchangeId,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.selectedPackage.goodsCode,
        exchangeId: this.form.exchangeId,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            try{
              // eslint-disable-next-line
              if (window.countLog) {
                // eslint-disable-next-line
                countLog.ready(function() {
                  // eslint-disable-next-line
                  countLog.init(function() {
                    // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
                  }, {
                    // 是否需要复制订单号，是为 1，不是为 0 
                    isCopy: 0, 
                    // 上报转化类型，具体见下表 
                    pageType: 0 
                  })
                })
              }
            } catch (err) {
              console.log(err)
              this.errlog = err.message;
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            this.$router.push({
              name: 'CQFlowADSuccess'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scope>
.container{
  background-color: #FA5038;
  padding-bottom: 3.5rem;
}
.header{
  .banner{
    width: 100%;
  }
}
.module-bg{
  width: 90%;
  margin: 0 auto;
  border: 2px solid #48c89f;
  border-radius: 6px;
  padding: 6px;
  background-color: #ffffff;
}
.mobile-form{
  margin: 0 1rem;
  padding: .8rem;
  img{
    width: 100%;
    border-radius: 12px;
  }
  .form-content{
    width: 90%;
    margin: 1rem auto;
    .el-form-item{
      margin-top: 1rem;
    }
    input{
      border-radius: 6px;
      font-size: 1rem;
    }
  }
  @keyframes buttonheartbeat{
    0%{
      transform: scale3d(1,1,1);
    }
    20%{
      transform: scale3d(1.03,1.03,1.03);;
    }
    40%{
      transform: scale3d(.9,.9,.9);
    }
    60%{
      transform: scale3d(1.03,1.03,1.03);
    }
    80%{
      transform: scale3d(1.03,1.03,1.03);
    }
    100%{
      transform: scale3d(.97,.97,.97);
    }
  }
  .submit-btn{
    margin: 0 auto;
    margin-top: 1rem;
    height: 2.9rem;
    img{
      animation: buttonheartbeat 5s infinite;
    }
    button{
      width: 100%;
      font-size: 1.3rem;
      font-weight: bold;
      border-radius: 36px;
      background: linear-gradient(rgb(224, 101, 234), rgb(159, 41, 224));
      border: 0;
    }
  }
}
.packages-form{
  .packages-info{
    >ul{
      display: flex;
      >li{
        flex: 1;
        font-size: .8rem;
        font-weight: bold;
        background-color: #f5f3f3;
        margin: .4rem;
        border-radius: 12px;
        >div{
          margin: .8rem .2rem;
        }
        .name{
          color: #e69a79;
        }
        .desc{
          color: #888;
        }
        &.selected{
          background-color: #88f3d1;
          .name{
            color: #e75e25;
          }
          .desc{
            color: #333;
          }
        }
      }
    }
    .tips{
      margin: 6px;
      font-size: .8rem;
      text-align: left;
      .tip{
        margin: 3px 0;
        i{
          color: #48c89f;
        }
      }
    }
  }
}
.user-notice{
  margin-top: 12px;
  font-size: .8rem;
  color: #222;
  .title{
    color: #48c89f;
    font-size: 1rem;
  }
  .content{
    text-align: left;
    margin: 6px;
    ul{
      margin-left: .4rem;
    }
  }
}
.img-desc{
  margin: 0 1.2rem;
  margin-top: 2.6rem;
  img{
    width: 100%;
  }
}
.notice{
  padding-top: 4rem;
  color: #fff;
  width: 94%;
  .title{
    font-size: 1.4rem;
    text-align: center;
  }
  ul{
    width: 90%;
    margin: 0 auto;
    font-size: .8rem;
    padding: 1rem;
    li{
      clear: both;
      overflow: hidden;
      
      margin-bottom: .2rem;
      .num{
        float: left;
        width: 1.4rem;
        line-height: 1.2rem;
      }
      .content{
        line-height: 1.2rem;
        margin-left: 1.3rem;

      }
    }
  }
}
.el-form-item {
  margin-bottom: .4rem;
}
.verify-controls{
  .el-input{
    width: 60%;
    input{
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      height: 40px;
      line-height: 40px;
      vertical-align: top;
    }
  }
  button{
    width: 40%;
    padding:0;
    height: 40px;
    line-height: 40px;
    border: 0;
    border-radius: 0;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    vertical-align: top;
  }
}
@keyframes fly{
   from{
     margin-top: 2rem;
     margin-bottom: 2rem;
   }
   to{
     margin-top: 3rem;
     margin-bottom: 1rem;
   }
 }
.show-more{
  width: 2rem;
  height: 2rem;
  margin: 2rem auto;
  border-bottom: 1px solid #fff;
  border-right: 1px solid #fff;
  position: relative;
  transform: rotate(45deg);
  animation: fly .5s infinite alternate;
  .inner-arrow{
    position: absolute;
    width: 2rem;
    height: 2rem;
    margin-left: -.5rem; 
    margin-top: -.5rem;
    border-bottom: 1px solid #fff;
    border-right: 1px solid #fff;
  }
}
.roll-order-infos{
  position: fixed;
  right: 0;
  top: 0;
  background-color: rgba(33, 33, 33, .6);
  color: #f3f3f3;
  font-size: .8rem;
  height: 2rem;
  overflow: hidden;
  padding: 0 1rem;
  width: 10rem;
  text-align: center;
  >div{
    margin: .5rem 0;
  }
  z-index: 1;
}
.tip{
  padding: 0 2rem;
  color: #fff;
  font-size: .8rem;
  margin-top: 2rem;
}
</style>